import { Amplify } from 'aws-amplify';
import type { AppConfig } from './environment';

/**
 * Configures the AWS Amplify library with the provided application configuration.
 * This function is designed to be called once during application startup.
 * @param {AppConfig} config - The fully validated application configuration.
 */
export function configureAmplify(config: AppConfig) {
  try {
    const { auth } = config;

    if (config.isDevelopment) {
      console.log('Configuring Amplify with:', {
        userPoolId: auth.userPoolId,
        userPoolClientId: auth.userPoolClientId,
        region: auth.region,
        environment: config.environment,
      });
    }

    // Amplify v6 configuration
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: auth.userPoolId,
          userPoolClientId: auth.userPoolClientId,
          loginWith: {
            email: true,
            phone: false,
            username: true,
          },
          signUpVerificationMethod: 'code',
          passwordFormat: {
            minLength: 8,
            requireLowercase: true,
            requireNumbers: true,
            requireSpecialCharacters: true,
            requireUppercase: true,
          },
        },
      },
    });

    if (config.isDevelopment) {
      console.log('Amplify configured successfully');
      // Verify the configuration was applied
      const currentConfig = Amplify.getConfig();
      console.log('Current Amplify config:', currentConfig);
    }

    // Final check to ensure Auth is configured
    if (!Amplify.getConfig()?.Auth?.Cognito?.userPoolId) {
      throw new Error('Amplify Auth configuration failed to apply.');
    }
  } catch (error) {
    console.error('Error configuring Amplify:', error);
    // Re-throw the error to be caught by the initialization logic in main.tsx
    throw error;
  }
}
